import { render, staticRenderFns } from "./UrbInt.vue?vue&type=template&id=08ef5943&scoped=true"
import script from "./UrbInt.vue?vue&type=script&lang=js"
export * from "./UrbInt.vue?vue&type=script&lang=js"
import style0 from "./UrbInt.vue?vue&type=style&index=0&id=08ef5943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef5943",
  null
  
)

export default component.exports